import { createReducer, on } from '@ngrx/store';
import { textActions } from '../actions/text.actions';
import { Text } from '../models';

export interface TextState {
    text: Record<string, { loaded: boolean; loading: boolean | null; text: Text | null }>;
}

export const initialState: TextState = {
    text: {},
};

export const textReducer = createReducer(
    initialState,
    on(textActions.getText, (state, action): TextState => {
        if (state.text[action.id]) {
            return state;
        }

        return {
            ...state,
            text: {
                ...state.text,
                [action.id]: { loaded: false, loading: null, text: null },
            },
        };
    }),
    on(textActions.getTextSuccess, (state, { payload }): TextState => ({
        ...state,
        text: {
            ...state.text,
            [payload.id]: { loaded: true, loading: false, text: payload },
        },
    })),
    on(textActions.getTextError, (state, { id }): TextState => ({
        ...state,
        text: {
            ...state.text,
            [id]: { loaded: false, loading: false, text: null },
        },
    })),
    on(textActions.setLoading, (state, payload): TextState => ({
        ...state,
        text: {
            ...state.text,
            [payload.id]: { loaded: false, loading: true, text: null },
        },
    })),
    on(textActions.clear, (): TextState => ({
        ...initialState,
    })),
);
